import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import Pricing from "./components/Pricing";
import Cleaners from "./components/Cleaners";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";
import Newsletter from "./components/Newsletter";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-900">
      <h1 className="sr-only">PureNest — Trusted House Cleaning Services & Online Booking</h1>
      <Navbar />
      <Hero />
      <Services />
      <HowItWorks />
      <Pricing />
      <Cleaners />
      <Testimonials />
      <FAQ />
      <CTA />
      <Newsletter />
      <Footer />
    </main>
  );
}